<template>
  <div class="container page password-page">
    <van-nav-bar :title="$t('setting.set_money_pwd')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#333" @click="back" />
      </template>
    </van-nav-bar>

    <div class="page-body">
      <section class="field-block">
        <p class="field-title">{{ uiText.firstPassword }}</p>
        <van-password-input
          :value="opw"
          :length="6"
          :focused="focusField === 'first'"
          @focus="restoreKeyboard('first')"
        />
      </section>

      <section class="field-block">
        <p class="field-title">{{ uiText.secondPassword }}</p>
        <van-password-input
          :value="tpw"
          :length="6"
          :focused="focusField === 'second'"
          @focus="restoreKeyboard('second')"
        />
      </section>

      <div class="submit-btn" @click="setPayPassword">{{ uiText.confirm }}</div>
    </div>

    <div v-if="keyboardVisible" class="custom-keyboard">
      <div
        v-for="key in keyboardKeys"
        :key="key.value"
        class="key-item"
        :class="`key-${key.type}`"
        @click="onKeyPress(key)"
      >
        <span v-if="key.type === 'digit'">{{ key.label }}</span>
        <span v-else-if="key.type === 'hide'" class="key-icon">⌨</span>
        <span v-else class="key-icon">⌫</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      opw: "",
      tpw: "",
      focusField: "first",
      keyboardVisible: true,
    };
  },
  computed: {
    keyboardKeys() {
      return [
        { type: "digit", label: "1", value: "1" },
        { type: "digit", label: "2", value: "2" },
        { type: "digit", label: "3", value: "3" },
        { type: "digit", label: "4", value: "4" },
        { type: "digit", label: "5", value: "5" },
        { type: "digit", label: "6", value: "6" },
        { type: "digit", label: "7", value: "7" },
        { type: "digit", label: "8", value: "8" },
        { type: "digit", label: "9", value: "9" },
        { type: "hide", label: "hide", value: "hide" },
        { type: "digit", label: "0", value: "0" },
        { type: "delete", label: "delete", value: "delete" },
      ];
    },
    uiText() {
      const lang = this.$t("auth.lang");
      const copy = {
        zh: {
          firstPassword: "请输入提现密码",
          secondPassword: "请再次输入提现密码",
          confirm: "确认",
        },
        en: {
          firstPassword: "Please enter your withdrawal password",
          secondPassword: "Please re-enter the withdrawal password",
          confirm: "Confirm",
        },
        ja: {
          firstPassword: "出金パスワードを入力してください",
          secondPassword: "出金パスワードを再入力してください",
          confirm: "確認",
        },
        kr: {
          firstPassword: "출금 비밀번호를 입력해 주세요",
          secondPassword: "출금 비밀번호를 다시 입력해 주세요",
          confirm: "확인",
        },
      };

      return copy[lang] || copy.zh;
    },
  },
  methods: {
    back() {
      window.history.back();
    },
    restoreKeyboard(field) {
      this.focusField = field;
      this.keyboardVisible = true;
    },
    onKeyPress(key) {
      if (key.type === "digit") {
        this.onKeyboardInput(key.value);
        return;
      }
      if (key.type === "delete") {
        this.onKeyboardDelete();
        return;
      }
      this.keyboardVisible = false;
    },
    onKeyboardInput(key) {
      if (!this.focusField) {
        this.focusField = this.opw.length < 6 ? "first" : "second";
        this.keyboardVisible = true;
      }

      if (this.focusField === "first" && this.opw.length < 6) {
        this.opw += key;
        if (this.opw.length === 6) {
          this.focusField = "second";
        }
        return;
      }

      if (this.focusField === "second" && this.tpw.length < 6) {
        this.tpw += key;
      }
    },
    onKeyboardDelete() {
      if (this.focusField === "second") {
        if (this.tpw.length > 0) {
          this.tpw = this.tpw.slice(0, -1);
        } else {
          this.focusField = "first";
          this.opw = this.opw.slice(0, -1);
        }
        return;
      }

      this.opw = this.opw.slice(0, -1);
    },
    setPayPassword() {
      if (this.opw.length !== 6) {
        this.$toast(this.$t("setting.money_place"));
        this.focusField = "first";
        return false;
      }
      if (this.tpw.length !== 6) {
        this.$toast(this.$t("setting.money_again_place"));
        this.focusField = "second";
        return false;
      }
      if (this.opw !== this.tpw) {
        this.$toast(this.$t("setting.pwd_error"));
        this.focusField = "second";
        return false;
      }

      this.$http({
        method: "post",
        data: { paypassword: this.opw },
        url: "user_set_paypw",
      }).then((res) => {
        if (res.code === 200) {
          this.$toast(res.msg);
          this.$router.replace({ path: this.$route.query.redirect || "/BindUsdt" });
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
      return true;
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

.password-page {
  min-height: 100vh;
  background: #fff;
}

.nav-bar {
  background: #fff;
}

.nav-bar ::v-deep .van-nav-bar__title,
.nav-bar ::v-deep .van-icon {
  color: #333;
}

.page-body {
  padding: 42px 24px 300px;
}

.field-block + .field-block {
  margin-top: 94px;
}

.field-title {
  margin: 0 0 26px;
  font-size: 28px;
  line-height: 1.4;
  color: #333;
  font-weight: 700;
  text-align: center;
}

.submit-btn {
  margin-top: 120px;
  width: calc(100% - 100px);
  height: 100px;
  line-height: 100px;
  border-radius: 100px;
  background: #e596b3;
  font-size: 32px;
  font-weight: 700;
  text-align: center;
  color: #fff;
  margin-left: auto;
  margin-right: auto;
}

::v-deep .van-password-input {
  margin: 0;
  width: 88%;
  margin-left: auto;
  margin-right: auto;
}

::v-deep .van-password-input__security {
  gap: 4px;
  height: 72px;
}

::v-deep .van-password-input__security li {
  flex: 1;
  border: none;
  border-radius: 18px;
  background: #f3f3f7;
}

::v-deep .van-password-input__item {
  border: none;
}

::v-deep .van-password-input__security i {
  width: 18px;
  height: 18px;
  background: #444;
}

.custom-keyboard {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
  padding: 8px 0 calc(env(safe-area-inset-bottom) + 8px);
  background: #f5f6fa;
}

.key-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 88px;
  border: 1px solid #eef0f4;
  border-radius: 18px;
  background: #fff;
  font-size: 38px;
  font-weight: 700;
  color: #2f4157;
}

.key-icon {
  font-size: 36px;
  font-weight: 700;
}
</style>
